import client from './main-client';

export const userTargetApi = (params) => client().get('/userTargets', { params });

export const updateUserTargetApi = (params) => client().patch(`userTargets/${params.id}`, params.param);

export const addUserTargetApi = (params) => client().post('userTargets', params);

export const fetchUserTargetAllyearsApi = (params) => client().get(`userTargets?getTargetYears=${params.getTargetYears}`);
